// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop-f5e2","image":"image-5b9c"};